/* eslint-disable */
import { AxiosResponse } from "axios";
import SpaToolsApiClient from "./base/SpaToolsApiClient";

export type Property = {
  id: number;
  name: string;
  titleInDropdown: string | null;
};

export type GetPropertyListResponse = {
  properties: Property[];
};

export type PropertyUpdateResponse = {
  unitBuilderUpdates: string;
  residentBuilderUpdates: string;
};

export type GroupAddition = {
  availableGroup: string;
  groupType: number;
};

export type GroupAdditionsResponce = {
  groups: GroupAddition[];
};

export type Group = {
  id: number;
  name: string;
  displaySendFinancials: boolean;
};

export type GroupsResponce = {
  groups: Group[];
};

export type EmployeeData = {
  employeeKey: string;
  employeeName: string;
  employeeID: string;
};

export type CommitteeInfo = {
  companyKey: number;
  groupType: number;
  committeeName: string;
};

export type MemberInfo = {
  key: string;
  committeeName: string;
  employeeKey: number;
  committeeMemberKey: number;
  residentKey: number;
  committeeKey: number;
  propertyName: string;
  groupName: string;
  residentContactKey: string;
  cm_Title: string;
  lastName: string;
  firstName: string;
  streetName: string;
  city: string;
  state: string;
  zip: string;
  committeeMemberContactKey: number;
  cmc_Email: string;
  cmc_Telephone: string;
  cmc_Type: string;
  noAccount: boolean;
  isEmailConfirmed: boolean;
  dateSubmittedFinCenStr: string;
  dateSubmittedFinCenStrPicker: any;
  finCEN: string;
  termLength: string;
  termStartStr: string;
  termStartStrPicker: any;
  termEndStr: string;
  termEndStrPicker: any;
  cm_SendFinancial:any;
  positions: string[];
  isDisabledAccount: boolean;
};

export type Position = {
  positionName: string;
  groupDisplay: string;
};

class ApplicationApi extends SpaToolsApiClient {
  async getPropertyListAsync(): Promise<
    AxiosResponse<GetPropertyListResponse>
  > {
    return this.get(`/GetPtopertyList`);
  }

  async updatePropertyAsync(
    propertyId: string
  ): Promise<AxiosResponse<PropertyUpdateResponse>> {
    return this.get(`/BuilderLinkUpdate?companykey=${propertyId}`);
  }

  async getGroupsByPropertyIdAsync(
    propertyId: string
  ): Promise<AxiosResponse<GroupsResponce>> {
    return this.get(`/GetGroups?propertyId=${propertyId}`);
  }

  async getEmployeeByEmailAsync(
    email: string
  ): Promise<AxiosResponse<EmployeeData>> {
    return this.get(`/search-employee-by-userId?userID=${email}`);
  }

  async getGroupAdditionsAsync(
    propertyId: string
  ): Promise<AxiosResponse<GroupAdditionsResponce>> {
    return this.get(`/get-groups-for-addition?companyKey=${propertyId}`);
  }

  async getMembers(comiteeId: string): Promise<AxiosResponse<MemberInfo>> {
    return this.get(`/Members/Get?comiteeId=${comiteeId}`);
  }

  async addCommitteeAsync(committee: FormData): Promise<AxiosResponse> {
    return this.post(`/committee-insert`, committee);
  }

  async addMemberAsync(member: FormData): Promise<AxiosResponse> {
    return this.post(`/Members/Post`, member);
  }

  async getPositionsAsync(): Promise<AxiosResponse> {
    return this.get(`/get-positions`);
  }

  async removeMemberAsync(
    CommitteeMemberKey: number,
    EmployeeKey: number
  ): Promise<AxiosResponse> {
    return this.post(
      `/Members/Delete?CommitteeMemberKey=${CommitteeMemberKey}&EmployeeKey=${EmployeeKey}`
    );
  }

  async getMemberInfoByAccountNumAsync(
    PropertyId: number | string,
    AccountId: number | string
  ): Promise<AxiosResponse> {
    return this.get(
      `/Members/GetMemberInfoByAccountNumGet?companyId=${PropertyId}&accountId=${AccountId}`
    );
  }
}

export default ApplicationApi;